export const addEditStudentsIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#first-name-group',
    intro: 'Click here to fill in the text field with the student’s first name.'
  },
  {
    element: '#middle-name-group',
    intro: 'Click here to fill in the text field with the student’s middle name. This is optional.'
  },
  {
    element: '#last-name-group',
    intro: 'Click here to fill in the text field with the student’s last name or initial.'
  },
  {
    element: '#usernameField',
    intro: 'Click here to edit the text field with a username for the student. It must have at least 5 characters.'
  },
  {
    element: '#passwordField',
    intro: 'Click here to edit the text field with a password for the student. It must have between 8 and 20 characters, including at least one letter and one number.'
  },
  {
    element: '#gradeField',
    intro: 'Click here to fill in the text field with the student’s grade.'
  },
  {
    element: '#sessionTimeField',
    intro: 'Click here to adjust the session time from 20 minutes. WordFlight recommends session times to stay between 15 and 25 minutes. Session times depend on student and class characteristics and needs. Contact your WordFlight Partner Success and Professional Learning Specialist if you have any questions.'
  },
  {
    element: '#taskTimerBarField',
    intro: 'Click here to turn off the Task Timer Bar. Some instructional tasks include a timer bar to aid in the development of automatic word recognition. At default, the Task Timer Bar is turned on and is recommended for most students. You may choose to disable the timer bar for students who have specific learning disabilities or anxieties about timed tasks. Contact your WordFlight Partner Success and Professional Learning Specialist if you have any questions.'
  },
  {
    element: '#extraSupportField',
    intro: 'Click here to turn on Extra Support. Extra Support provides the student with the maximum visual and auditory support at the onset of each instructional task. It also slows the covering time for covered tasks. The support will be reduced as the student is successful in the task. You may choose to turn on Extra Support for students with specific learning disabilities, multilingual learners needing extra support, or students who score at high risk on the WordFlight Diagnostic. This setting does not impact assessment tasks within WordFlight. Contact your WordFlight Partner Success and Professional Learning Specialist if you have any questions.'
  },
  {
    element: '#ellField',
    intro: 'Click here to include the ELL status for informational and data analysis purposes. This does not impact the curriculum settings.'
  },
  {
    element: '#teamLeaderboardField',
    intro: 'Click here to turn off the Team Leaderboard function. At default, the Team Leaderboard function is turned on for all students. The Team Leaderboard function allows the student to be randomly assigned to one of the four school-based teams. The student then works with their team to try to earn the most points for the weekly team challenge. The winning team members earn an extra character for the following week. You may choose to disable the Team Leaderboard if the team system is not beneficial for your student.'
  },
  {
    element: '#subscriptionTypeFields',
    intro: 'Click here to select the Subscription Type. WordFlight includes a free screener and a paid intervention system.'
  }
];
